var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sliders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9999 9.28125L11 18.5625",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 3.4375L10.9999 5.84375",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.9999 9.28125C11.9492 9.28125 12.7187 8.51174 12.7187 7.5625C12.7187 6.61326 11.9492 5.84375 10.9999 5.84375C10.0507 5.84375 9.28119 6.61326 9.28119 7.5625C9.28119 8.51174 10.0507 9.28125 10.9999 9.28125Z",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.1874 16.1562L17.1875 18.5625",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.1875 3.4375L17.1874 12.7188",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.1874 16.1562C18.1367 16.1562 18.9062 15.3867 18.9062 14.4375C18.9062 13.4883 18.1367 12.7188 17.1874 12.7188C16.2382 12.7188 15.4687 13.4883 15.4687 14.4375C15.4687 15.3867 16.2382 16.1562 17.1874 16.1562Z",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.81245 13.4062L4.81238 18.5625",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.81238 3.4375L4.81245 9.96875",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.81244 13.4062C5.76168 13.4062 6.53119 12.6367 6.53119 11.6875C6.53119 10.7383 5.76168 9.96875 4.81244 9.96875C3.8632 9.96875 3.09369 10.7383 3.09369 11.6875C3.09369 12.6367 3.8632 13.4062 4.81244 13.4062Z",
    stroke: "#163E6E",
    strokeOpacity: 0.66,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.3c66a69f3c343ff25cd2cdfde084f6c2.svg";
export { ForwardRef as ReactComponent };